import React from 'react'
import { useAdjustmentListContext } from './Context'
import type { DataTableProps } from '@ztechapps/webui.data-tools'
import { DataTable } from '@ztechapps/webui.data-tools'
import { adjustmentListFieldConfig as fieldsCore } from './constants'
import { ListRow } from './ListRow'
import { ListHeader } from './ListHeader'
import type { SetOptional } from 'type-fest'
import type { Adjustment } from '@ztechapps/common.contract'

export const AdjustmentList = ({
  row,
  head,
  fields,
  listResult,
  tableOptions,
  ...props
}: SetOptional<DataTableProps<Adjustment>, 'listResult' | 'fields'>) => {
  const { adjustmentList, adjustmentListWithSelection } = useAdjustmentListContext()
  const { list } = adjustmentListWithSelection
  const defaultListResult = { ...adjustmentList, list }
  return (
    <DataTable
      fields={fields ?? fieldsCore}
      listResult={listResult ?? defaultListResult}
      row={row ?? ListRow}
      head={head ?? ListHeader}
      tableOptions={{
        ...tableOptions,
        responsive: true,
      }}
      stats={'adjustments'}
      name="adjustment-list-v1"
      {...props}
    />
  )
}
